import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase";

type EnsureWelcomeTrialResponse = {
  success: boolean;
  granted: boolean;
  alreadyGranted: boolean;
  hours: number | null;
};

/**
 * Garante que o bônus de 30 min de terapeuta foi concedido (idempotente).
 * Deve ser chamado logo após cadastro/conversão para terapeuta.
 */
export async function ensureTherapistWelcomeTrial(): Promise<EnsureWelcomeTrialResponse> {
  const callable = httpsCallable<void, EnsureWelcomeTrialResponse>(
    functions,
    "ensureTherapistWelcomeTrial"
  );
  const result = await callable();
  return result.data;
}
